'use strict';
const nodeIsFirstArg = [
		'flip',
		'initialiseTitle',
		'updateTitle',
		'removeSubIdea',
		'changeParent',
		'updateAttr',
		'positionBefore',
		'addLink',
		'removeLink',
		'updateLinkAttr'
	],
	parentFirstChildThird = [
		'insertIntermediate',
		'addSubIdea',
		'paste'
	];
module.exports = function getEventContextNode(cmd, args) {
	if (!args) {
		return false;
	}
	if (nodeIsFirstArg.indexOf(cmd) >= 0) {
		return args[0];
	}
	if (parentFirstChildThird.indexOf(cmd) >= 0) {
		return args[2] || args[0];
	}
	if (cmd === 'batch') {
		return args.map(evtArr => getEventContextNode(evtArr[0], evtArr.slice(1))).find(t => t);
	}

	return false;
};
